export default __webpack_public_path__ + "static/usage-step-2-81d45119ef250b10f7499f17e2643216.svg";